const $body = $('body');
const navMenu = $('.s-header > .main-nav')

class Menu {

  constructor(opt = {}) {

    this.init()

  }

  init() {

    const tlMenuOpen = new TimelineMax({ paused: true, onReverseComplete:()=>{ tlMenuOpen.set(".menu-full", {visibility:'invisible'});}  });
     new TimelineMax({ paused: true});
    const menuVideo = document.getElementById('menuVideo');

    //tlMenuOpen.to('.s-header .brand svg > *', 0.15, {fill:"#FFF", ease:Power3.easeInOut}, 0)
    let menuSplitLink = new SplitText( '.menu-full .nav-main-link', {type:"words, chars"});
    TweenMax.set('.menu-full .nav-main-link > div > div', {y:30});
    tlMenuOpen.set('.menu-full .zoom-line', {autoAlpha:0});
    tlMenuOpen.set('.menu-full .zoom-line .line', {width:0, height:0});
    tlMenuOpen.set('.menu-full .zoom-line svg path', {drawSVG:"0%"});

    tlMenuOpen.set(".menu-full", {visibility:'visible'});
    tlMenuOpen.staggerTo(".menu-full .pane", 0.7, {scaleX:1.05, ease:Power3.easeInOut}, 0.05, 0)
    tlMenuOpen.from(".menu-full .video-container", 1.2, {autoAlpha:0, x:150, ease:Power3.easeOut}, 0.55)

    tlMenuOpen.staggerTo('.menu-full .zoom-line', 1, {autoAlpha:1, ease:Power3.easeInOut}, 0.15, 0.5)
    tlMenuOpen.staggerTo('.menu-full .nav-main-link > div > div', 0.6, {y:0,  ease:Power3.easeOut, overwrite:"all"}, 0.010, 0.5)
    tlMenuOpen.staggerTo('.menu-full .zoom-line svg path', 1, {drawSVG:"100%", ease:Power3.easeInOut}, 0.15, 0.5)
    tlMenuOpen.staggerTo('.menu-full .zoom-line .line', 1, {width:"100%", height:"100%", ease:Power3.easeInOut}, 0.15, 0.5)
    /*tlMenuOpen.from(".menu-full .main-nav ", 0.8, {x:150, ease:Power3.easeOut}, 0.25)
    tlMenuOpen.staggerFrom(".menu-full .main-nav li", 0.8, {x:75, opacity:0, skewX:10, ease:Power3.easeInOut}, 0.03, 0.25)*/

    $('.toggle-menu').on('click', (e) => {

      e.preventDefault();
      $body.toggleClass('openMenu');
      if ($body.hasClass("openMenu")){
        //menuVideo.currentTime = 0;
        //menuVideo.play();
        tlMenuOpen.restart(0).duration(3);
      } else {
        tlMenuOpen.reverse(0).duration(2);
      }

    })

    $('.main-nav .nav-main-link').on('click', (e) => {
      if ($body.hasClass("openMenu")){
        $body.removeClass('openMenu');
        tlMenuOpen.reverse(0).duration(2);
      }
    })

    $('.menu-trigger .contact').on('click', () => {
      if ($body.hasClass("openMenu")){
        $body.removeClass('openMenu');
        tlMenuOpen.reverse(0).duration(2);
      }
    })

    $('.main-nav a.nav-main-link, .menu-trigger .contact').on('click', (e) => {
      TweenMax.to(navMenu.find('li.active svg path'), 0.4, {drawSVG:"0%", ease:Power3.easeInOut, overwrite:"all"}, 0)
      TweenMax.staggerTo(navMenu.find('li.active .txt > div > div'), 0.4, {y:30,  ease:Power3.easeOut, overwrite:"all"}, 0.01, 0)
      $('.main-nav .active').removeClass('active');
    });

    navMenu.find('li').each((index, elem) => {

      let menuSplitLink = new SplitText( $(elem).find('.txt'), {type:"words, chars"});
      TweenMax.set($(elem).find('svg path'), {drawSVG:"0%"});
      TweenMax.set($(elem).find('.txt > div > div'), {y:30});

      $(elem).not('.active').find('.nav-main-link').on( "mouseenter", (e) => {
        if ($(elem).hasClass('active')) {return;}
        TweenMax.to($(elem).find('svg path'), 0.8, {drawSVG:"100%", ease:Power3.easeInOut, overwrite:"all"}, 0)
        TweenMax.staggerTo($(elem).find('.txt > div > div'), 0.6, {y:0,  ease:Power3.easeOut, overwrite:"all"}, 0.02, 0)
      }).on( "mouseleave", (e) => {
        if ($(elem).hasClass('active')) {return;}
        TweenMax.to($(elem).find('svg path'), 0.4, {drawSVG:"0%", ease:Power3.easeInOut, overwrite:"all"}, 0)
        TweenMax.staggerTo($(elem).find('.txt > div > div'), 0.4, {y:30,  ease:Power3.easeOut, overwrite:"all"}, 0.01, 0)
      });

      $(elem).find('.nav-main-link').on('click', (e) => {
        TweenMax.to($(elem).find('svg path'), 0.8, {drawSVG:"100%", ease:Power3.easeInOut, overwrite:"all"}, 0)
        TweenMax.staggerTo($(elem).find('.txt > div > div'), 0.6, {y:0,  ease:Power3.easeOut, overwrite:"all"}, 0.02, 0)
      })

    })

    $('.menu-full').mousemove(function(e){

    	let xMouse = e.pageX - $(this).offset().left - ($(this).width()/2)
    	let yMouse = e.pageY - $(this).offset().top - ($(this).height()/2)

      $('*[data-mouse-parallax]').each(function(){

        var factor = parseFloat($(this).data('mouse-parallax'));
    		let xFinal = xMouse * factor;
        let yFinal = yMouse * factor;
        TweenMax.to($(this), 1.2, {x:xFinal, y:yFinal});

      });

    })

  }

}

export default Menu;
